import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import {
    deleteServices,
    editServices,
    getServices,
    updateServices,
} from '../servicesThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'services';

export const servicesSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getServices });
        handleRequestThunk({
            builder,
            request: deleteServices,
            isDelete: true,
        });
        handleRequestThunk({ builder, request: editServices });
        handleRequestThunk({ builder, request: updateServices });
    },
});

export const services = servicesSlice.reducer;
